export const FirebaseConfig = {
    apiKey: 'AIzaSyDdL05PMCX8o_ysuCV8byYw-MnXPjeKBCA',
    authDomain: 'mbox-410813.firebaseapp.com',
    projectId: 'mbox-410813',
    storageBucket: 'mbox-410813.appspot.com',
    messagingSenderId: '339462138231',
    appId: '1:339462138231:web:2ebdf233c3bc42c4ff5972'
};
